import { PropsWithChildren } from 'react'
import { Helmet } from 'react-helmet'
import { useCustomDomain } from '../hooks/useCustomDomain'

type SectionProps = PropsWithChildren<{
  className?: string
  title: string
}>

const Section = ({ title, children, className }: SectionProps) => {
  const { customDomain } = useCustomDomain()

  return (
    <section className={className}>
      <Helmet>
        <title>
          {title}
          {customDomain ? '' : ' | wowaudit'}
        </title>
      </Helmet>
      <div>{children}</div>
    </section>
  )
}

export default Section
